/* eslint-disable tsdoc/syntax */
import { OperationDTO } from "@zenith/services/transactions";

/**
 * Gets the element with the string status and style classes necessary for each status.
 * @function
 * @name getStatusText
 * @kind function
 * @param {OperationDTO.status} status The intended status.
 * @returns {React.ReactNode} The element with the string status and style classes.
 * @exports
 */
export function getStatusText(status: OperationDTO.status): React.ReactNode {
  function formatStatus() {
    switch (status) {
      case OperationDTO.status.DECLINED:
        return {
          status: "Declined",
          style:
            "rounded-md border border-solid border-red-500 bg-red-100 text-red-500",
        };

      case OperationDTO.status.EXPIRED:
        return {
          status: "Expired",
          style:
            "rounded-md border border-solid border-gray-600 bg-gray-100 text-gray-600",
        };

      case OperationDTO.status.PENDING:
        return {
          status: "Pending",
          style:
            "rounded-md border border-solid border-yellow-500 bg-yellow-100 text-yellow-500",
        };

      case OperationDTO.status.SUCCESS:
        return {
          status: "Successful",
          style:
            "rounded-md border border-solid border-green-400 bg-accent-success bg-opacity-10 text-green-400",
        };

      case OperationDTO.status.FAILED:
        return {
          status: "Failed",
          style:
            "rounded-md border border-solid border-red-400 bg-red-100 bg-opacity-10 text-red-400",
        };

      case OperationDTO.status.REVERSED:
        return {
          status: "Reversed",
          style:
            "rounded-md border border-solid border-gray-600 bg-gray-100 text-gray-600",
        };

      default: {
        const label = String(status ?? "")
          .toLowerCase()
          .split("_")
          .filter(Boolean)
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
        return {
          status: label || "Unknown",
          style:
            "rounded-md border border-solid border-gray-600 bg-gray-100 text-gray-600",
        };
      }
    }
  }

  const formattedStatus = formatStatus();

  return (
    <div
      className={`flex h-6 items-center justify-center p-2 px-2 py-0.5 ${formattedStatus.style}`}
    >
      <p className="text-xs">{formattedStatus.status}</p>
    </div>
  );
}
